import { ReactNode } from 'react';

import { getCdnUrlForFile } from '@willow/shared-iso';
import { VerticalSpacing } from '@willow/shared-web';
import { PortalLoginBranding } from '@willow/types-iso';

import { AuthLayout } from '../auth/AuthLayout';

// The default host belongs to no single Portal, so it carries Willow's own branding, the same
// generic page the shared Auth0 login shows on this host today.
const WILLOW_BRANDING: PortalLoginBranding = {
  name: 'Willow Servicing',
  logoUrl: getCdnUrlForFile('portalLogoDefault'),
};

interface Props {
  documentTitle: string;
  title: string;
  description?: ReactNode;
  testId: string;
  children: ReactNode;
}

export const FindPortalLayout = ({ documentTitle, title, description, testId, children }: Props) => (
  <AuthLayout
    portal={WILLOW_BRANDING}
    documentTitle={documentTitle}
    title={title}
    description={description}
    faq="login"
  >
    <div data-testid={testId}>
      <VerticalSpacing spacing={2}>{children}</VerticalSpacing>
    </div>
  </AuthLayout>
);
